<template>
  <a-modal 
    title="猎头信息"
    width="637px"
    :maskClosable="false"
    :destroyOnClose="true"
    v-model="visible"
    @cancel="close"
  >
      <template slot="footer">
        <a-button key="back" @click="close">取消</a-button>
      </template>
      <a-spin :spinning="!hunterInfo.report_data" style="width: 100%">
        <div v-if="hunterInfo.report_data">
          <h3>基本信息</h3>
          <a-row>
            <a-col span="12">
              <p>中文名：{{ hunterInfo.name }}</p>
            </a-col>
            <a-col span="12">
              <p>邮箱：{{ hunterInfo.email }}</p>
            </a-col>
          </a-row>
          <a-row>
            <a-col span="12">
              <p>英文名：{{ hunterInfo.name_en }}</p>
            </a-col>
            <a-col span="12">
              <p>电话：{{ hunterInfo.tel }}</p>
            </a-col>
          </a-row>
          <a-row>
            <a-col span="12">
              <p>
                签约状态：{{
                  hunterInfo.is_sub_user
                    ? "猎企成员"
                    : hunterInfo.hunter.is_sign == "0"
                    ? "未签约"
                    : hunterInfo.hunter.is_enterprise == "NO"
                    ? "已签约猎头"
                    : "已签约猎企"
                }}
              </p>
            </a-col>
            <a-col span="12">
              <p>
                合同期限：{{
                  hunterInfo.contract.start_time | format("YYYY-MM-DD")
                }}
                至 {{ hunterInfo.contract.end_time | format("YYYY-MM-DD") }}
              </p>
            </a-col>
          </a-row>
          <a-row>
            <a-col span="12">
              <p>所在地区：{{ hunterInfo.city_name }}</p>
            </a-col>
            <a-col span="12">
              <p>最近登录时间：{{ hunterInfo.login_at }}</p>
            </a-col>
          </a-row>
          <p>所属猎企：{{ hunterInfo.company }}</p>
          <div style="align-items: flex-start">
            擅长行业：
            <p style="flex: 1">
              <span
                v-for="(item, i) in hunterInfo.hunter.specialized_industry"
                :key="i"
              >
                {{ item.first_category_name
                }}{{ item.second_category_name ? "/" : ""
                }}{{ item.second_category_name
                }}{{
                  i === hunterInfo.hunter.specialized_industry.length - 1
                    ? ""
                    : "、"
                }}
              </span>
            </p>
          </div>
          <div style="align-items: flex-start" class="model-list">
            擅长职能：
            <p style="flex: 1">
              <span
                v-for="(item, i) in hunterInfo.hunter.specialized_function"
                :key="i"
              >
                {{ item.first_category_name
                }}{{ item.second_category_name ? "/" : ""
                }}{{ item.second_category_name
                }}{{ item.third_category_name ? "/" : ""
                }}{{ item.third_category_name
                }}{{
                  i === hunterInfo.hunter.specialized_function.length - 1
                    ? ""
                    : "、"
                }}
              </span>
            </p>
          </div>
          <a-divider></a-divider>
          <div class="listtitle">做单信息</div>
          <a-row class="row-content" type="flex" justify="start" align="middle">
            <a-col class="col">
              <span
                >最近一次做单：<span
                  class="blue"
                  style="cursor:pointer;"
                  @click="
                    $router.push(
                      '/order/detail/' + hunterInfo.report_data.latest_post.id
                    )
                  "
                  v-if="hunterInfo.report_data.latest_post.id"
                  >{{ hunterInfo.report_data.latest_post.order_no }}</span
                ></span
              >
            </a-col>
            <a-col class="col">
              <span
                >最近一次做单时间：{{
                  hunterInfo.report_data.latest_post.created_at || "-"
                }}</span
              >
            </a-col>
            <a-col class="col">
              <span
                >接单数：<span class="blue">{{
                  hunterInfo.report_data.post_count
                }}</span></span
              >
            </a-col>
            <a-col class="col">
              <span
                >一面数：<span class="blue">{{
                  hunterInfo.report_data.interview_count
                }}</span></span
              >
            </a-col>
            <a-col class="col">
              <span
                >offer数：<span class="blue">{{
                  hunterInfo.report_data.offer_count
                }}</span></span
              >
            </a-col>
            <a-col class="col">
              <span
                >入职数：<span class="blue">{{
                  hunterInfo.report_data.entry_count
                }}</span></span
              >
            </a-col>
            <a-col class="col">
              <span
                >过保数：<span class="blue">{{
                  hunterInfo.report_data.complete_count
                }}</span></span
              >
            </a-col>
          </a-row>
        </div>
      </a-spin>
    </a-modal>
</template>

<script>
  export default {
    name: 'HunterModal',
    data() {
      return{
        visible: false,
        hunterInfo: {}
      }
    },
    methods: {
      show(hunter) {
        this.hunterInfo = hunter;
        this.visible = true;
      },
      close() {
        this.hunterInfo = {};
        this.visible = false;
      }
    }

  }
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  padding-bottom: 20px;
}
.model-list {
  font-size: 14px;
  padding-bottom: 15px;
  display: flex;
  align-items: center;
  div:first-child {
    width: 200px;
  }
}
.info {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
  padding-bottom: 15px;
  display: flex;
  align-items: center;
  div {
    flex: 1;
  }
}
.tips {
  color: #fc5646;
  font-size: 14px;
  margin-top: 20px;
}
.listtitle {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 10px;
}
.row-content {
  margin-left: 10px;
  .col {
    width: 50%;
    margin-bottom: 10px;
    .active {
      color: #35b5fe;
    }
  }
  .row {
    width: 100%;
    margin-bottom: 10px;
    .active {
      color: #35b5fe;
    }
  }
}
.blue {
  color: #35b5fe;
}
</style>